export default "__VITE_ASSET__D50BcYf4__"